import {
  Ban,
  CableIcon,
  CircleCheck,
  Coins,
  EyeClosedIcon,
  FileX,
  UserX,
} from 'lucide-react';

export const quickFiltersDisplay: Record<
  string,
  {
    /**
     * Nazwa przycisku dla czytnika ekranu. Stała, bo stan niesie już
     * `aria-pressed` — nazwa zmieniająca się przy kliknięciu brzmi jak inny
     * przycisk. Treść z `labelOn`/`labelOff` zostaje w dymku.
     */
    name: string;
    labelOn: string;
    labelOff: string;
    icon: React.ReactNode;
  }
> = {
  onlyActiveTours: {
    name: 'Tylko aktywne wyjazdy',
    labelOn: 'Pokaż nieaktywne wyjazdy',
    labelOff: 'Pokaż tylko aktywne wyjazdy',
    icon: <CircleCheck />,
  },
  hideMatched: {
    name: 'Ukryj dopasowane',
    labelOn: 'Dopasowane ukryte, pokaż je',
    labelOff: 'Dopasowane widoczne, ukryj je',
    icon: <CableIcon />,
  },
  hideIgnored: {
    name: 'Ukryj zignorowane',
    labelOn: 'Zignorowane ukryte, pokaż je',
    labelOff: 'Zignorowane widoczne, ukryj je',
    icon: <EyeClosedIcon />,
  },
  showRemoved: {
    name: 'Pokaż zarchiwizowane',
    labelOn: 'Zarchiwizowane ukryte',
    labelOff: 'Zarchiwizowane pokazywane',
    icon: <EyeClosedIcon />,
  },
  hideUnsigned: {
    name: 'Ukryj niepodpisane',
    labelOn: 'Niepodpisane umowy ukryte',
    labelOff: 'Niepodpisane umowy pokazywane',
    icon: <FileX />,
  },
  hideWithdrawn: {
    name: 'Ukryj rezygnacje',
    labelOn: 'Rezygnacje ukryte, pokaż je',
    labelOff: 'Rezygnacje widoczne, ukryj je',
    icon: <UserX />,
  },
  hideCancelled: {
    name: 'Ukryj anulowane',
    labelOn: 'Anulowane ukryte, pokaż je',
    labelOff: 'Anulowane widoczne, ukryj je',
    icon: <Ban />,
  },
  withUnallocatedRemainder: {
    name: 'Tylko do rozdysponowania',
    labelOn: 'Tylko do rozdysponowania, pokaż wszystkie',
    labelOff: 'Wszystkie transakcje, pokaż tylko do rozdysponowania',
    icon: <Coins />,
  },
};
